import {
  MenuItem,
  InputAdornment,
  Button,
  FormControl,
  Grid,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import { toUTC } from "../../formatUTC";
import Loading from "../../loading";
import SelectedBranch from "../../selectedBranch";
import Snackbar from "../../snackbar";
import { styles } from "./styles";
import InputFileReader from "../../fileReader";
import DescriptionComponent from "../../descriptionComponent";
import NumberFormatCustom from "../../numberFormat";
import InputFormat from "../../../partials/inputForm";
import SelectDateTime from "../../../partials/selectDateTime";
import { getNumberOnString } from "../../../partials/validateNumber";
import LabelForm from "../../../partials/labelForm";

class CreateVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      voucher: {
        discount: "",
        type: "percent",
        startedDate: new Date().getTime(),
        endedDate: new Date().getTime(),
        title: "",
        shortDescription: "",
        description: "",
        itemTime: 0,
        times: 1,
        imageGallery: [],
        forAll: 0,
      },
      selectedBranch: [],
    };
    this.imgURL = "";
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUploadImage = this.handleUploadImage.bind(this);
    this.changeArrBranch = this.changeArrBranch.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    if (e.target.type === "checkbox") {
      value = e.target.checked ? 1 : 0;
    }
    if (name === "itemTime" || name === "times" || name === "discount") {
      value = getNumberOnString(value);
    }
    let voucher = this.state.voucher;
    voucher[name] = value;
    this.setState({ voucher });
  };
  handleSubComponentChange = (name, value) => {
    let voucher = this.state.voucher;
    voucher[name] = value;
    this.setState({ voucher });
  };
  handleChangeDate = (name, date) => {
    var voucher = this.state.voucher;
    let milisecondInLocal =
      date && date._isAMomentObject ? date.valueOf() : moment().valueOf();
    voucher[name] = milisecondInLocal;
    this.setState({ voucher });
  };
  async handleSubmit(imgVoucherURL = null) {
    let { t } = this.props;
    const _this = this;
    let arrBranch = this.state.selectedBranch;
    let data = this.state.voucher;
    data.startedDate = toUTC(data.startedDate);
    data.endedDate = toUTC(data.endedDate);
    data.imageGallery = JSON.stringify(data.imageGallery);
    data.itemTime = data.itemTime || 0;
    data.times = data.times || 1;
    let check = await this.props.voucherDispatch.addNewVoucher({
      data: data,
      arrBranch: arrBranch,
      imgVoucherURL: imgVoucherURL,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.mSnackbar.handleClick(t("voucher_addvoucher_create_successfully"));
      setTimeout(function () {
        _this.props.createDone("success");
      }, 1000);
    } else {
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_create_unsuccessfully") + " " + check.message,
        "error"
      );
    }
  }
  async handleUploadImage() {
    this.loading.startLoading();
    let t = this.props;
    if (this.InputFileReader.getFile() !== null) {
      let check = await this.props.uploadDispatch.saveStorage({
        files: this.InputFileReader.getFile(),
        code: this.props.serviceCode,
        imgPre: "",
        type: "img-voucher",
      });
      if (check.code === 1) this.handleSubmit(check.data.previewLink);
      else {
        this.mSnackbar.handleClick(
          t("voucher_addvoucher_upload_image_unsuccessfully") +
            " " +
            check.message,
          "error"
        );
        this.handleSubmit();
      }
    } else if (this.InputFileReader.getSrc() !== null) {
      this.handleSubmit(this.InputFileReader.getSrc());
    } else {
      this.handleSubmit();
    }
  }
  changeArrBranch(arrBranch) {
    this.setState({ selectedBranch: arrBranch });
  }
  handleCheck() {
    let voucher = this.state.voucher;
    let { t } = this.props;
    voucher.discount = Number(voucher.discount);
    if (voucher.type == "percent") voucher.discount /= 100;
    if (!this.state.selectedBranch.length && voucher.forAll == 0)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_nothing_apply_branch"),
        "warning"
      );
    else if (voucher.discount === 0)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_discount"),
        "warning"
      );
    else if (!voucher.startedDate)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_startedDate_discount"),
        "warning"
      );
    else if (!voucher.endedDate)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_endedDate_discount"),
        "warning"
      );
    else if (voucher.endedDate - voucher.startedDate < 0)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_endedDate_more_than_startedDate"),
        "warning"
      );
    else if (!voucher.title)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_title"),
        "warning"
      );
    else if (!voucher.shortDescription)
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_please_add_shortDescription"),
        "warning"
      );
    else if (voucher.type === "percent" && voucher.discount > 1)
      this.mSnackbar.handleClick(
        t(
          "voucher_addvoucher_please_enter_discount_less_than_or_equal_to_100_for_percent"
        ),
        "warning"
      );
    else {
      this.handleUploadImage();
    }
  }
  render() {
    const { classes, t } = this.props;
    return (
      <Paper className={classes.root}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <form className={classes.container} noValidate autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6}>
              <InputFormat
                label={t("voucher_addvoucher_discount")}
                name="discount"
                required
                placeholder={"0"}
                value={this.state.voucher.discount}
                onChange={this.handleChange}
                fullWidth={true}
                InputProps={{
                  inputComponent: NumberFormatCustom,
                  endAdornment: (
                    <InputAdornment position="end">
                      {this.state.voucher.type === "percent"
                        ? "%"
                        : this.props.currencyCode}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputFormat
                select
                label={t("voucher_addvoucher_type")}
                name="type"
                required
                value={this.state.voucher.type}
                onChange={this.handleChange}
                fullWidth={true}
              >
                <MenuItem value="percent">
                  {t("voucher_addvoucher_percent")}
                </MenuItem>
                <MenuItem value="value">{this.props.currencyCode}</MenuItem>
              </InputFormat>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <SelectDateTime
                label={t("voucher_addvoucher_start_date")}
                name="lastTime"
                required
                fullWidth
                InputProps={{
                  className: classes.input,
                }}
                timeFormat="hh:mm A"
                dateFormat="DD/MM/YYYY"
                value={this.state.voucher.startedDate}
                onChange={(date) => this.handleChangeDate("startedDate", date)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <SelectDateTime
                label={t("voucher_addvoucher_end_date")}
                name="lastTime"
                required
                fullWidth
                InputProps={{
                  className: classes.input,
                }}
                timeFormat="hh:mm A"
                dateFormat="DD/MM/YYYY"
                value={this.state.voucher.endedDate || new Date().getTime()}
                onChange={(date) => this.handleChangeDate("endedDate", date)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputFormat
                label={t("voucher_listvoucher_tablehead_item_time")}
                name="itemTime"
                required
                value={this.state.voucher.itemTime}
                onChange={this.handleChange}
                fullWidth={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {t("menu_menuitem_editmenuitem_minute")}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputFormat
                label={t("voucher_listvoucher_tablehead_times")}
                name="times"
                required
                value={this.state.voucher.times}
                onChange={this.handleChange}
                fullWidth={true}
              />
            </Grid>
            {!this.state.voucher.forAll ? (
              <Grid item xs={12} sm={12}>
                <SelectedBranch
                  onRef={(id) => (this.SelectedBranch = id)}
                  multiple={true}
                  required={true}
                  handleChangeBranch={this.changeArrBranch}
                  disabled={this.state.voucher.forAll == 1}
                  value={this.state.selectedBranch}
                />
              </Grid>
            ) : (
              ""
            )}
            <Grid item xs={12} sm={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.voucher.forAll == 1 ? true : false}
                    name="forAll"
                    onChange={this.handleChange}
                  />
                }
                className={classes.label}
                label={t("voucher_listvoucher_cardvoucher_all_branch")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputFormat
                label={t("voucher_listvoucher_cardvoucher_title")}
                name="title"
                required
                value={this.state.voucher.title}
                onChange={this.handleChange}
                fullWidth={true}
                inputProps={{
                  maxLength: 255,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <InputFormat
                label={t("voucher_listvoucher_cardvoucher_shortDescription")}
                name="shortDescription"
                required
                value={this.state.voucher.shortDescription}
                onChange={this.handleChange}
                fullWidth={true}
                inputProps={{
                  maxLength: 255,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <DescriptionComponent
                onRef={(id) => (this.DescriptionComponent = id)}
                title={t("voucher_listvoucher_cardvoucher_description")}
                handleSubComponentChange={this.handleSubComponentChange}
                description={this.state.voucher.description}
                spacing={3}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={{ paddingBottom: "0" }}>
              <LabelForm label={t("voucher_addvoucher_image_voucher")} />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl>
                <InputFileReader
                  onRef={(id) => (this.InputFileReader = id)}
                  style={classes}
                  container="square"
                  selectStorageMode={true}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container justify="flex-end" className={classes.marginTop}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.handleCheck()}
            >
              {t("voucher_addvoucher_save")}
            </Button>
          </Grid>
        </form>
      </Paper>
    );
  }
}

CreateVoucher.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
});

const mapDispatch = (dispatch) => ({
  uploadDispatch: dispatch.upload,
  voucherDispatch: dispatch.voucher,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(CreateVoucher)
  )
);
